<template>
  <el-card v-loading="loading" :body-style="{padding: 0, height: '20rem'}">
    <div class="rs-card-header">
      <h4 class="wallet-head">
        Open Units ( Total: {{ numOpenUnits }} )
      </h4>
      <el-switch
        v-model="enableParking"
        active-text="View all"
        inactive-text="Disable parking"
        @change="getFacilityOpenUnits"
      >
      </el-switch>
    </div>
    <el-table
      @row-click="routeToUnit"
      :data="openUnits"
      :header-cell-style="{padding: 0}"
      :default-sort = "{prop: 'availableDays', order: 'descending'}"
      max-height="290"
    >
      <el-table-column
        prop="name"
        label="Unit"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="computedSize"
        label="Size"
        sortable
      >
      </el-table-column>
      <el-table-column
        label="Asking Price"
        prop="askingPrice"
        sortable
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.askingPrice">
            {{ scope.row.askingPrice | currencySign($root.state.facilityData)}}
            <span v-if="scope.row.securityFee">
              + {{ scope.row.securityFee | currencySign($root.state.facilityData) }}
            </span>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Days Available"
        prop="availableDays"
        sortable
      >
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { UNITS_API_BASE } from '../env';
import { getOpenDaysFromCurrentDate } from '../utils/timing';
import { computeUnitPricing } from '../utils/pricing';

export default {
  name: 'FacilityOpenUnits',
  props: { facility: { type: String, required: true } },
  async mounted() {
    this.loading = true;
    await this.getFacilityOpenUnits();
    this.loading = false;
  },
  watch: {
    async facility() {
      await this.getFacilityOpenUnits();
    },
  },
  computed: {
    numOpenUnits() {
      return this.openUnits.length;
    }
  },
  data() {
    return {
      enableParking: false,
      openUnits: [],
      loading: true,
    };
  },
  methods: {
    async getFacilityOpenUnits() {
      this.loading = true;
      try {
        const response = await axios.get(`${UNITS_API_BASE}/dashboard/open/units/${this.facility}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            ...(this.enableParking ? {} : { types: 'Warehouse,Office,Other' }),
          },
        });
        const data = response.data.result;
        this.openUnits = data.units.map(unit => ({
          ...unit,
          availableDays: unit.lastMoveOut ? this.getOpenDays(unit.lastMoveOut) : this.getOpenDays(unit.createdDate),
          askingPrice: computeUnitPricing(unit, this.$root.state.facilityData),
          securityFee: this.$root.state.facilityData.securityFee && this.$root.state.facilityData.securityFee.enabled ? this.computeSecurityFee(unit.computedSize) : 0,
        }));
      } catch (err) {
        this.$message.error({
          message: 'Falied to get Open Units',
        });
        console.error(error);
      }
      this.loading = false;
    },
    computeSecurityFee(unitSize) {
      return Math.round(((this.$root.state.facilityData.securityFee.fee / 100) * unitSize) * 100) / 100;
    },
    getOpenDays(date) {
      return getOpenDaysFromCurrentDate(date);
    },
    routeToUnit(row) {
      this.$router.push({ name: 'Facility Unit', params: { facility: this.facility, unit: row._id } });
    },
  },
};
</script>

<style scoped>
.wallet-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
.rs-card-header {
  padding: 0.5rem;
  border-bottom: solid 1px #efefef;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityOpenUnits.vue